// src/shared/modules/admin/NotFound.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { RingLoader } from "react-spinners";
import errorimg from "../../../assets/Images/smiley-4832484_1280.png";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className='flex items-center justify-center min-h-screen bg-gray-100 px-4'>
      <div className='bg-white shadow-xl rounded-2xl p-10 max-w-md w-full text-center'>
        <img src={errorimg} alt='404' className='w-32 mx-auto mb-6' />

        <h1 className='text-7xl font-bold text-red-500'>404</h1>

        <h2 className='text-2xl font-semibold text-gray-700 mt-2'>Page Not Found</h2>

        <p className='text-gray-500 mt-3 text-sm'>The page you are looking for might have been removed, renamed or temporarily unavailable.</p>

        <div className='flex justify-center mt-6'>
          <RingLoader color='#ebb569' size={60} />
        </div>

        <button
          onClick={() => navigate("/")}
          className='mt-8 w-full bg-amber-400 hover:bg-amber-500 text-white font-semibold py-2.5 rounded-lg transition duration-300'
        >
          Go Back Home
        </button>
      </div>
    </div>
  );
}

export default NotFound;
